module.exports.lunatic = {
  vi: {
    title: 'Kẻ điên (Lunatic) trong Avalon: bắt buộc Thất bại và chiến thuật',
    description:
      'Kẻ điên có thể chọn Thành công trong Avalon không? Không. Tìm hiểu luật bắt buộc chọn Thất bại, điểm khác Kẻ bạo lực và vì sao một thẻ Thất bại chưa chắc làm hỏng Nhiệm vụ.',
    keywords: ['Kẻ điên', 'Vai trò', 'Luật chơi', 'Mẹo chơi'],
  },
  pt: {
    title: 'Lunático em Avalon: Falha obrigatória e estratégia',
    description:
      'O Lunático pode jogar Sucesso em Avalon? Não. Entenda a Falha obrigatória, a diferença para o Bruto e as missões que exigem duas Falhas.',
    keywords: ['Lunático', 'Papel', 'Regras', 'Dicas'],
  },
  en: {
    title: 'Lunatic in Avalon: Must-Fail Rule & Strategy',
    description:
      'Can the Lunatic play Success in Avalon? No. Learn the mandatory Fail rule, how it differs from Brute and why one Fail does not always fail a mission.',
    keywords: ['Lunatic', 'Role', 'Rules', 'Tips'],
  },
  ru: {
    title: 'Лунатик в Авалоне: обязательный провал и стратегия',
    description:
      'Может ли Лунатик дать успех в Авалоне? Нет. Правило обязательного провала, отличие от Брута и миссии, которым нужны две карты провала.',
    keywords: ['Лунатик', 'Роль', 'Правила', 'Советы'],
  },
  'zh-TW': {
    title: '阿瓦隆瘋子：強制失敗與任務策略',
    description: '阿瓦隆瘋子可以出成功嗎？不可以。了解強制失敗規則、與野蠻人的區別，以及需要兩張失敗牌的任務。',
    keywords: ['瘋子', '角色', '規則', '攻略'],
  },
  'zh-CN': {
    title: '阿瓦隆疯子：强制失败与任务策略',
    description: '阿瓦隆疯子可以出成功吗？不可以。了解强制失败规则、与野蛮人的区别，以及需要两张失败牌的任务。',
    keywords: ['疯子', '角色', '规则', '建议'],
  },
  es: {
    title: 'Lunático en Avalon: Fracaso obligatorio y estrategia',
    description:
      '¿Puede el Lunático jugar Éxito en Avalon? No. Conoce el Fracaso obligatorio, la diferencia con el Bruto y las misiones que necesitan dos Fracasos.',
    keywords: ['Lunático', 'Rol', 'Reglas', 'Consejos'],
  },
};
